import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取项目列表
 */
export function getProjectList(data) {
  return fetch ({
    url: '/sale/project/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取单位列表
 */
export function getUnitSimpleList(data) {
  return fetch ({
    url: '/auth/subPlatform/propertyUnit/simpleList',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 获取电销模板列表
 */
export function getTelemarketingTemplateList() {
    return fetch ({
      url: '/sale/telemarketingTemplate/simpleList',
      method: 'get',

    })
  }


  /**
 * @param {Object} data
 * 获取跟踪模板列表
 */
export function getTrackTemplateList() {
    return fetch ({
      url: '/sale/trackTemplate/simpleList',
      method: 'get',
    })
  }




/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentList(params) {
  return fetch ({
    url: '/auth/subPlatform/department/simpleList',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 添加项目
 */
export function addProject(data) {
  return fetch({
    url: '/sale/project/save',
    method: 'POST',
    data
  })
}




/**
 * @param {Object} data
 * 删除项目
 */
export function deleteProject(data) {
  return fetch({
    url: '/sale/project/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 修改状态
 */
export function updateStatus(data) {
    return fetch({
      url: '/sale/project/updateStatus',
      method: 'POST',
      data
    })
  }


/**
 * @param {Object} data
 * 生成外呼计划
 */
export function createPlan(data) {
    return fetch({
      url: '/sale/telemarketing/plan/createPlan',
      method: 'POST',
      data
    })
  }

/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getProjectDetail(params) {
  return fetch({
    url: '/sale/project/detail',
    method: 'GET',
    params
  })
}

/**
 * @param {Object} params
 * 销售项目下拉
 */
export function getProjectSimpleList(data) {
  return fetch({
    url: '/sale/project/simpleList',
    method: 'POST',
    data
  })
}

export function importSaleProject(data) {
  return fetch({
    url: '/sale/project/lift/importSaleProject',
    method: 'POST',
    data
  })
}


export function exportTemplate(data) {
  return formAxios({
    url: '/sale/project/lift/exportTemplate',
    method: 'POST',
    data
  })
}







// WEBPACK FOOTER //
// ./src/api/salesManagement/ProjectManagement.js